import { apiClient } from './client';
import type { ApiResponse, PaginatedResponse, PaginationParams } from '../types/api';
import type {
  EmotionLog,
  CreateEmotionLogRequest,
  EmotionFilters,
  EmotionStats,
  EmotionPerformanceCorrelation,
} from '../types/emotion';
import type { EmotionCalendarData as DashboardEmotionCalendarData } from '../types/dashboard';

export interface GetEmotionLogsParams extends PaginationParams, EmotionFilters {}

export const emotionApi = {
  getEmotionLogs: (params: GetEmotionLogsParams): Promise<ApiResponse<PaginatedResponse<EmotionLog>>> =>
    apiClient.get('/emotions', { params }),

  getEmotionLogById: (id: number): Promise<ApiResponse<EmotionLog>> =>
    apiClient.get(`/emotions/${id}`),

  createEmotionLog: (data: CreateEmotionLogRequest): Promise<ApiResponse<EmotionLog>> =>
    apiClient.post('/emotions', data),

  deleteEmotionLog: (id: number): Promise<ApiResponse<void>> =>
    apiClient.delete(`/emotions/${id}`),

  getTodayEmotion: (): Promise<ApiResponse<EmotionLog | null>> =>
    apiClient.get('/emotions/today'),

  getEmotionStats: (params?: { start_date?: string; end_date?: string }): Promise<ApiResponse<EmotionStats>> =>
    apiClient.get('/emotions/stats', { params }),

  getEmotionCalendar: (params: { year: number; month: number }): Promise<ApiResponse<DashboardEmotionCalendarData[]>> =>
    apiClient.get('/emotions/calendar', { params }),

  getEmotionPerformanceCorrelation: (): Promise<ApiResponse<EmotionPerformanceCorrelation[]>> =>
    apiClient.get('/emotions/performance-correlation'),
};
